var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "container content-padding" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h3", [_vm._v(_vm._s(_vm.$t("message.menu.notifications")))]),
        _vm._v(" "),
        _c("hr")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _vm.isFetching
        ? _c("div", { staticClass: "text-center w-100 mb-4" }, [
            _c("i", { staticClass: "far fa-circle-notch fa-spin fa-3x" })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _vm._l(_vm.notifications, function(item, index) {
            return _c(
              "router-link",
              {
                key: index,
                attrs: {
                  to: {
                    name: "My Reservation",
                    params: { id: item.notification_data.order_id }
                  }
                }
              },
              [
                _c("div", { staticClass: "media" }, [
                  _c("img", {
                    staticClass:
                      "align-self-center mr-3 rounded-circle img-fluid",
                    attrs: {
                      src: item.notification_data.professional_picture,
                      width: "75",
                      alt: "..."
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "media-body ml-2 align-self-center" },
                    [
                      _c(
                        "p",
                        {
                          staticClass: "has-read",
                          style: !item.is_read
                            ? { color: "#000" }
                            : { color: "#484848" }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm._f("firstName")(
                                  item.notification_data.professional_name
                                )
                              ) +
                              "\n              " +
                              _vm._s(item.activity_type_name) +
                              "\n              "
                          ),
                          item.notification_data.order_code
                            ? _c("span", [
                                _vm._v(
                                  "\n                #" +
                                    _vm._s(item.notification_data.order_code) +
                                    "\n              "
                                )
                              ])
                            : item.notification_data.order_id
                            ? _c("span", [
                                _vm._v(
                                  "\n                #" +
                                    _vm._s(item.notification_data.order_id) +
                                    "\n              "
                                )
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass: "m-0",
                          staticStyle: {
                            color: "#03BBD3",
                            "font-weight": "500"
                          }
                        },
                        [_vm._v(_vm._s(_vm.convertTimespan(item.time)))]
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("hr")
              ]
            )
          }),
          _vm._v(" "),
          !_vm.isError
            ? _c(
                "button",
                {
                  staticClass: "btn btn-success w-100",
                  attrs: { disabled: _vm.isFetching },
                  on: { click: _vm.loadMore }
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("message.button.load_more")) + "\n      "
                  )
                ]
              )
            : _vm._e()
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e77f352a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e77f352a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/notifications/Index.vue
// module id = 2149
// module chunks = 0